import type { AudienceFilterDto } from "@intelligems/ig-types";

export const hasPurchaseLikelihoodAudienceFilter = (
  filters: AudienceFilterDto[] | undefined | null
): boolean =>
  Boolean(
    filters?.some((filter) =>
      filter.expression?.some(
        (node) => node.query?.type === "purchaseLikelihood"
      )
    )
  );
